import React from "react";
import "./Skeleton.css";

const Skeleton = () => {
  return (
    <div className="skeleton-wrapper">
      {/* Header Section */}
      <div className="skeleton-header">
        <div className="skeleton-logo"></div>
        <div className="skeleton-nav">
          <div className="skeleton-nav-item"></div>
          <div className="skeleton-nav-item"></div>
          <div className="skeleton-nav-item"></div>
        </div>
      </div>

      {/* Main Content */}
      <div className="skeleton-main">
        {/* Stats Cards */}
        <div className="skeleton-stats">
          <div className="skeleton-stat-card">
            <div className="skeleton-stat-icon"></div>
            <div className="skeleton-stat-info">
              <div className="skeleton-stat-title"></div>
              <div className="skeleton-stat-value"></div>
            </div>
          </div>
          <div className="skeleton-stat-card">
            <div className="skeleton-stat-icon"></div>
            <div className="skeleton-stat-info">
              <div className="skeleton-stat-title"></div>
              <div className="skeleton-stat-value"></div>
            </div>
          </div>
          <div className="skeleton-stat-card">
            <div className="skeleton-stat-icon"></div>
            <div className="skeleton-stat-info">
              <div className="skeleton-stat-title"></div>
              <div className="skeleton-stat-value"></div>
            </div>
          </div>
        </div>

        {/* Content Cards */}
        <div className="skeleton-content">
          <div className="skeleton-card">
            <div className="skeleton-card-header"></div>
            <div className="skeleton-card-body">
              <div className="skeleton-line"></div>
              <div className="skeleton-line"></div>
              <div className="skeleton-line"></div>
            </div>
          </div>
          <div className="skeleton-card">
            <div className="skeleton-card-header"></div>
            <div className="skeleton-card-body">
              <div className="skeleton-line"></div>
              <div className="skeleton-line"></div>
              <div className="skeleton-line"></div>
            </div>
          </div>
        </div>

        {/* Recent Activity */}
        <div className="skeleton-activity">
          <div className="skeleton-activity-header"></div>
          <div className="skeleton-activity-list">
            {[...Array(4)].map((_, index) => (
              <div key={index} className="skeleton-activity-item">
                <div className="skeleton-avatar"></div>
                <div className="skeleton-activity-content">
                  <div className="skeleton-activity-title"></div>
                  <div className="skeleton-activity-text"></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Skeleton;
